import styled from "@emotion/styled";
import anime from 'animejs';
import { graphql, StaticQuery } from "gatsby";
import React from "react";
import DesignerIntroComponent from '../contents/designer-intro.component';
import { Container } from '../grid/grid.component';
const exitAnimationDuration = 800;
// const enterAnimationDelay = 500;

class DesignerList extends React.Component {
  exitAnimation({ node, e, exit, entry }) {
    // console.log(node);
    // console.log(e.target);
    // console.log(exit);
    // console.log(entry);

    const target = e.target.querySelector('.image-wrapper-hero');
    const targetBounds = target.getBoundingClientRect();
    target.classList.add('zoom');
    anime({
      targets: target,
      top: [`${Math.round(targetBounds.top)}px`, 0],
      left: [`${Math.round(targetBounds.left)}px`, 0],
      width: [targetBounds.width, window.innerWidth],
      height: [targetBounds.height, window.innerHeight],
      duration: exitAnimationDuration - 100,
      easing: 'easeInOutQuart'
    })
  }
  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            designers: allPrismicCompany {
                nodes {
                  id
                  data {
                    name
                    intro
                    text
                    image {
                      ...prismicCompanyDataImageFragment
                    }
                    website {
                      url
                    }
                    image_caption
                  }
                }
            }
            
          }
        `
        }
        render={data => (
          <Designers>
            <Container>
              {data.designers.nodes.map(designer => (
                <DesignerIntroComponent key={designer.id} {...designer.data} />
              ))}

            </Container>
          </Designers>
        )}
      />

    )
  }
}

export default DesignerList


const Designers = styled.div`
  
  .designer-intro{
    margin-bottom: 200px;
  }
  .designer-intro:last-of-type{
    margin-bottom: 0;
  }
  .designer-intro:nth-of-type(even){
    > div{
      flex-direction: row-reverse;
    }
  }
`
